
import Vue from 'vue';
import Component from "vue-class-component";
import {namespace} from "vuex-class";
import {Prop} from "vue-property-decorator";
import {IErrors} from "@/model/IErrors";
import {IServiceProvider} from "@/model/Service/serviceProviderInterfaces";
import {IShortServiceProvider} from "@/model/shortInterfaces";

const lockerModule = namespace("lockerModule");
const serviceProviderModule = namespace("serviceProviderModule");

@Component({
})
export default class ServiceProviderSearch extends Vue {

  @serviceProviderModule.Getter('serviceProviders')
  private serviceProviders!: IServiceProvider[];

  @serviceProviderModule.Action('fetchServiceProviders')
  private fetchServiceProviders!: () => void;

  @Prop()
  protected value!: any;
  @Prop({default: false})
  protected erasable!: boolean;
  @Prop()
  protected filterFn!: (each: IServiceProvider) => boolean;
  @Prop()
  protected errorMessages!: IErrors[];
  @Prop({default: ''})
  protected emptyOptionLabel!: string;
  @Prop({default: false})
  protected onlyActive!: boolean;

  get isErasable(): boolean {
    return this.erasable !== false;
  }

  get serviceProviderItems() {
    const serviceProviders = this.serviceProviders;
    let ret: any = (serviceProviders || []);
    if (this.filterFn) {
      ret = ret.filter(this.filterFn);
    }
    // @todo test
    if (this.onlyActive !== false) {
      ret = ret.filter((each: IServiceProvider) => each.active && !each.deleted_at);
    }

    ret = ret.map((serviceProvider: IShortServiceProvider) => ({
          text: serviceProvider.name + ' (#' + serviceProvider.id + ')',
          value: serviceProvider.id,
        }));
    ret.unshift({
      text: this.emptyOptionLabel,
      value: 0,
    });
    return ret;
  }

  created() {
    if (!this.serviceProviders || !this.serviceProviders.length) {
      this.fetchServiceProviders();
    }
  }

  protected onEraseClicked() {
    if (this.isErasable) {
      this.$emit('serviceProviderSelected', null);
    }
  }

  protected onServiceProviderSelected(newServiceProviderId: number) {
    this.$emit('serviceProviderSelected', newServiceProviderId);
  }

}

